'use client'

import { FormattedMessage } from 'react-intl'
import { Button } from '@vinted/web-ui'

import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'

import useFilterReset from '../../../hooks/useFilterReset'

const FilterReset = () => {
  const {
    state: { dynamicFilters },
  } = useCatalogContext()
  const { selectedDynamicFilters } = dynamicFilters

  const { resetFilters, selectedStaticFiltersWithoutQuery } = useFilterReset()

  if (
    !selectedStaticFiltersWithoutQuery.length &&
    !selectedDynamicFilters.some(selectedFilter => {
      if (selectedFilter.ids.length) return true

      return false
    })
  )
    return null

  return (
    <Button
      onClick={resetFilters}
      text={<FormattedMessage id="catalog.reset_filters" />}
      styling="flat"
      size="small"
      testId="catalog-reset-filters-button"
    />
  )
}

export default FilterReset
